import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useItemPhotos, useReorderItemPhotos } from '@/hooks/item';
import { ItemPhotoOrderModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, NoFooterModal, SuccessModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: ItemPhotoOrderModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { itemId, photos, onClose } = modal;

  const photosR = useItemPhotos(itemId, false);
  const submitR = useReorderItemPhotos(itemId, photos);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      photosR.refetch();
    }
  }, [submitR.kind]);

  useEffect(() => {
    submitR.mutate();
  }, []);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_photo_order.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.item_photo_order.title')}
        onClose={onClose}
      />
    );
  }

  const body = submitR.kind === 'Loading' ? <LoadingBodyModal height={40} /> : <></>;

  return (
    <NoFooterModal
      title={t('modal.item_photo_order.title')}
      onClose={onClose}
      body={body}
      containerStyle={{ width: 500 }}
      modalName="item_photo_order"
    />
  );
};

export default View;
